import Root from './Root';

import HomeScreen from './Home';
import condominiumPages from './Condominium';
import DashboardScreen from './Dashboard';
import RegisterScreen from './Register';
import AddCondominium from './AddCondominium';

import withAuth from '../hocs/withAuth';

export default [
  {
    component: Root,
    routes: [
      {
        path: '/register',
        exact: true,
        component: RegisterScreen,
      },
      {
        path: '/addcondominium/:referral',
        exact: true,
        component: withAuth(AddCondominium),
      },
      {
        path: '/dashboard',
        exact: true,
        component: withAuth(DashboardScreen),
      },
      ...condominiumPages,
      {
        path: '/:slug?',
        exact: true,
        component: HomeScreen,
      },
    ],
  },
];
